// extracted by mini-css-extract-plugin
module.exports = {"description":"ProductGallery_description__rH8rT","gallery":"ProductGallery_gallery__mVlhP","swiperTool":"ProductGallery_swiperTool__5Vs_5"};